import type { RouteObject } from "react-router-dom";

/** Siblings rather than nested: a song is a screen of its own, never beside its library's list */
export const songLibrariesRoutes: RouteObject[] = [
    {
        index: true,
        lazy: () => import("./routes/_index/SongLibrariesIndexScreen"),
    },

    {
        path: ":songLibraryId",
        lazy: () => import("./routes/song-libraries/SongLibraryScreen"),
    },

    {
        path: ":songLibraryId/view-song/:songLibrarySongId",
        lazy: () => import("./routes/song-libraries/view-song/SongLibrarySongScreen"),
    },
];
